import { connect } from 'react-redux';
import { getCurrentQuery } from '@hc/redux-saga-router-plus/hclib/selectors';
import { routeChange } from '@hc/redux-saga-router-plus/hclib/actions';
import { downloadReportSection } from 'actions/download-report';

import { getChartDataMSA } from 'selectors/chart-data';
import { getReportStatusInitialLoadComplete } from 'selectors/report-status';
import { getIsExcelDownloadAllowed } from 'selectors/report-permissions';

import PropertyExplorerMarketAnalysisChartButton from 'legacy/components/PropertyExplorerMarketAnalysisChartButton';

import {
  getOneYearMarketRiskOfDecline,
  getMarketStatus
} from 'selectors/report-data';

import { getChartDataRiskOfDeclinePercentValue } from 'selectors/chart-data';
import { analyticsEvent } from 'actions/analytics';
import { EVENTS } from 'legacy/appstore/events';

const mapStateToProps = (state) => {
  const { chartModal } = getCurrentQuery(state);
  return {
    chartModal,
    riskOfDeclineOneYear: getChartDataRiskOfDeclinePercentValue(state),
    riskOfDecline: getOneYearMarketRiskOfDecline(state),
    msa: getChartDataMSA(state), // We need tha actual data so will build apporeate selector etc at that time
    isExcelDownloadAllowed: getIsExcelDownloadAllowed(state),
    isReportLoaded: getReportStatusInitialLoadComplete(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: () => {
      dispatch(analyticsEvent(EVENTS.CHART_BUTTON_MARKET));
    },
    onClose: () => {
      dispatch(
        routeChange({
          options: { inherit: true, replace: true },
          query: { chartModal: undefined }
        })
      );
    },
    handleClickDownloadSection: () =>
      dispatch(downloadReportSection('marketAnalysis'))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyExplorerMarketAnalysisChartButton);
